/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Dawood Touseef",
  title: "Hi all, I'm Dawood Touseef",
  subTitle: emoji(
    "A passionate Full Stack web Developer and SoftWare Developer 🚀 having an experience of building Web and Desktop applications with JavaScript / Django / Flask and some other cool libraries and frameworks."
  ),
  resumeLink:"https://drive.google.com/file/d/1wE5hceo16A5jQ83-8l6wX7_-sN5JYbfr/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/DawoodTouseef",
  linkedin: "https://www.linkedin.com/in/dawood-thouseef-2a2905228/",
  gmail: "tdawood140@gmail.com@gmail.com",
  stackoverflow: "https://stackoverflow.com/users/19386979/dawood-thouseef",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡Develop highly interactive web applications and become an Artificial Intelligence Full Stack Application Developer."
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "MySQl",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    },

    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Ubuntu",
      fontAwesomeClassname: "fab fa-ubuntu"
    },
    {
      skillName: "Fedora",
      fontAwesomeClassname: "fab fa-fedora"
    },
    {
      skillName: "Andriod Development",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Angular Js",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "postgresql",
      fontAwesomeClassname: "fas fa-database"
    },  
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Canara Engineering College",
      logo: require("./assets/images/Canara_Engineering_College_logo.png"),
      subHeader: "B.E. in Computer Science and Design",
      duration: "December 2022- October 2025",
     // desc: "Participated in Many Hackathon",
      //descBullets: [
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      //]
    },
    {
      schoolName: "Shaheen falcon PU College",
      logo: require("./assets/images/falcon.jpg"),
      subHeader: "Pre-Unversity of College -DKPU",
      duration: "Jun 2019 - March 2021",
      desc: "Ranked Distinction in DKPU",
      //descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Language Known 
const language = {
  viewlanguageBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Language: "English", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Language: "Hindi",
      progressPercentage: "60%"
    },
    {
      Language: "Kannada",
      progressPercentage: "80%"
    },
    {
      Language: "Malayalam", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Language: "Tamil", //Insert stack or technology you have experience in
      progressPercentage: "10%" //Insert relative proficiency in percentage
    },
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};
// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Low Code Developer",
      company: "Novigo Solutions",
      companylogo: require("./assets/images/novigo-logo.png"),
      date: "Nov 2023 – Nov 2023",
      desc:  "Improved skills in Low Code App development and problem-solving through hands-on projects and teamwork.",
      
    },
    /*codelabsystemscom_logo.jpg*/
    {
      role:"Mern Stack Intern",
      company:"CodeLab System",
      companylogo: require("./assets/images/codelabsystemscom_logo.jpg"),
       date: "Feb 2025 – May 2025",
      desc:  "Designed to simplify the development of scalable and high-performance web applications.",
    },
    {
      role:"Inside Sales Representative ",
      company:"Glowlogics Solutions",
      companylogo: require("./assets/images/glowlogics_logo.jpeg"),
      date: "Jul 2025 – Present",
      desc:  "An inside sales representative drives remote sales via calls, emails, and digital tools, focusing on lead follow-up, customer communication, and meeting quotas while building long-term client relationships.",
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Dark Patterns Buster",
      subtitle:
        "Appreciations Certificate from Dark Patterns Buster",
      image: require("./assets/images/IIT.png"),
      imageAlt: "DBPH Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1vZxzcMLzEhag4As9lGgKFha8frE-Fr7r/view?usp=sharing"
        },
      ]
    },
    {
      title: "Using Python to Access Web Data",
      subtitle:
        "Completed the course  'Using Python to Access Web Data'  course authorized by University of Michigan and offered through Coursera ",
      image: require("./assets/images/coursera-logo-square.jpg"),
      imageAlt: "Coursera Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1FBpQmR7iiY-iICeMtuMy3QRcvopJeFsk/view?usp=sharing"
        },
      ]
    },
  ],
  display:true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Medium",
  subtitle:
    "",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@tdawood140/building-a-website-using-reflex-in-python-2edba4eec4a6",
      title: "Building a Website Using Reflex in Python",
      description:
        "Building the website using Reflex in python."
    },
    {
      url: "https://medium.com/@tdawood140/exploring-gpt-oss-openais-open-weight-models-with-ollama-f36f8d2906fc",
      title: "Exploring gpt-oss: OpenAI’s Open-Weight Models with Ollama",
      description:
        "Exploring gpt-oss: OpenAI’s Open-Weight Models with Ollama"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7348848706",
  email_address: "tdawood140@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable =true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  language,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
